import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Fieldset, Label, Theme, YStack } from "tamagui";
import { StyledSelectButton } from "../GeneralStyledComponents";
import { XStack } from "../Stacks";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
type BooleanButtonField = boolean | undefined;
export const BooleanYesNoButtonField = () => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<BooleanButtonField>();
  const {
    label,
    isOptional
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const id = useId();
  const inputId = `${id}_boolean_button_input`;
  return <Fieldset data-sentry-element="Fieldset" data-sentry-component="BooleanYesNoButtonField" data-sentry-source-file="BooleanYesNoButtonField.tsx">
      <Theme name={error ? "red_alt2" : "granted"} forceClassName data-sentry-element="Theme" data-sentry-source-file="BooleanYesNoButtonField.tsx">
        <YStack data-sentry-element="YStack" data-sentry-source-file="BooleanYesNoButtonField.tsx">
          {label ? <Label htmlFor={inputId} size="$4">
              {label}
              {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
            </Label> : null}
          <XStack gap="$2" justifyContent="flex-start" alignItems="center" data-sentry-element="XStack" data-sentry-source-file="BooleanYesNoButtonField.tsx">
            <StyledSelectButton onPress={() => field.onChange(field.value === true ? undefined : true)} selected={field.value === true} disabled={isSubmitting} width={112} data-sentry-element="StyledSelectButton" data-sentry-source-file="BooleanYesNoButtonField.tsx">
              Yes
            </StyledSelectButton>
            <StyledSelectButton onPress={() => field.onChange(field.value === false ? undefined : false)} selected={field.value === false} disabled={isSubmitting} width={112} data-sentry-element="StyledSelectButton" data-sentry-source-file="BooleanYesNoButtonField.tsx">
              No
            </StyledSelectButton>
          </XStack>
          <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="BooleanYesNoButtonField.tsx" />
        </YStack>
      </Theme>
    </Fieldset>;
};